import { render, staticRenderFns } from "./noticeZh.vue?vue&type=template&id=1d542053&scoped=true&"
import script from "./noticeZh.vue?vue&type=script&lang=js&"
export * from "./noticeZh.vue?vue&type=script&lang=js&"
import style0 from "./noticeZh.vue?vue&type=style&index=0&id=1d542053&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d542053",
  null
  
)

export default component.exports